import Button from '../../../../../component/ui/Button';
import { hasPermission } from '../../../../../utils/controller';

const CreateCreditNoteHeader = ({
	id,
	user,
	loading,
	suburl,
	navigate,
	setIsCreditNoteAutoSave,
	handleSubmitCreditNote,
}) => {
	return (
		<div className="header-position-sticky">
			<div className="product-pg-header">
				<p>
					{id ? 'Update ' : 'Create New '}
					Credit Note
				</p>
				<div className="add-product-button">
					<Button
						type="button"
						className="btn-primary mt-0 px-4"
						button="Save"
						loader={loading}
						disabled={
							loading ||
							(id
								? !hasPermission('sales.credit_notes.edit', user?.role?.role_permissions)
								: !hasPermission('sales.credit_notes.create', user?.role?.role_permissions))
						}
						onClick={() => {
							setIsCreditNoteAutoSave(false);
							handleSubmitCreditNote(1);
						}}
					/>
					<Button
						type="button"
						className="mt-0 btn-danger add-pro"
						button=""
						close
						onClick={() => navigate(`/user/${suburl}/sales/credit-note`)}
					/>
				</div>
			</div>
		</div>
	);
};
export default CreateCreditNoteHeader;
